/**
 *
 * WidgetResponseRate
 *
 */

import "./index.less"

import { HISTORICAL_ANALYSIS, MEASURE_STATUS } from "../../utils/constants"
import ProgressBar from "../ProgressBar"
import React from "react"
import { Popover, Spin, Tooltip } from "antd"
import WeekResponse from "../WeekResponse"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { get } from "lodash"
import { isModuleBySlug } from "../../utils/storage"
import { loadTexts } from "../../utils/i18n"
import { QuestionCircleFilled } from "@ant-design/icons"

/* eslint-disable react/prefer-stateless-function */
class WidgetResponseRate extends React.Component {
  intl = loadTexts("dashboard")

  componentDidMount() {
    if(!this.props.async) {
      return
    }

    const {
      match: { params },
    } = this.props

    this.props.getMeasureRate(params.id)
  }

  showArrowVariation(rate_variation) {
    if(rate_variation === 0) {
      return <></>
    }

    return rate_variation > 0 ? (
      <div className="arrow-up increase" />
    ) : <div className="arrow-up decrease" />
  }

  render() {
    const { data, dataRate, isLoading, week } = this.props
    
    const isHistoricalAnalysis = isModuleBySlug(HISTORICAL_ANALYSIS)
    return (
      <div className="WidgetResponseRate boxShadow">
        <div className="subtitle_section color-black">
          <span className="WidgetResponseRate-title">
            {this.props.title || this.intl.responseRateWidget.responseRate} 
            {(this.props.data.id_measure_status === MEASURE_STATUS.in_progress.id_measure_status) && 
            <Popover content={() => {
              return (
                <span>
                  Este indicador es actualizado <br />
                  en <b>tiempo real</b>, según los <br/>
                  colaboradores respondan la <br/>
                  encuesta.
                </span>
              )
            }}>
              <QuestionCircleFilled style={{color: "#A7A3A3"}}/>
            </Popover>}
            
          </span>
        </div>
        {isLoading ? (
          <div className="loadingSpin">
            <Spin size="large" />
          </div>
        ) : (
          <div className="WidgetResponseRate-body">
            <div className="WidgetResponseRate-body-data">
              <div
                className="WidgetResponseRate-body-data-percent"
                style={{ color: get(data, "rate.rate_color", "black") }}>
                {get(data, "rate.rate_visible", 0)}
                <span className="color-gray-low">
                  {get(data, "employees", 0)}/{get(data, "recipients", 0)}{" "}
                  {this.intl.responseRateWidget.employees}
                </span>
              </div>
              <div className="WidgetResponseRate-body-data-medition">
                {dataRate &&
                  dataRate.calculate_comparative.show &&
                  isHistoricalAnalysis && (
                    <div>
                      {/* <b style={{ display: "block", fontSize: "12px" }}>Medición anterior</b> */}
                      <b style={{ display: "block", fontSize: "12px" }}>
                        { get(data, 'rate_variation') !== null ? this.intl.responseRateWidget.variation : <></>}
                      </b>
                      <span
                        style={{ display: "inline-flex", marginTop: "5px" }}>
                        {get(data, 'rate_variation') !== null ? get(data, 'rate_variation') + '%' : <></>} 
                        {get(data, 'rate_variation') !== null ? this.showArrowVariation(get(data, 'rate_variation')) : <></>}
                      </span>
                    </div>
                  )}
              </div>
            </div>

            <div>
              <ProgressBar
                custom={{
                  color: get(data, "rate.rate_color", "red"),
                  value: get(data, "rate.rate", 0),
                }}
              />
            </div>
            {week && (
              <div>
                <WeekResponse
                  lineValue
                  dataAll={[
                    { percent: 10, name: 12, employees: 10, childs: [] },
                    { percent: 10, name: 13, employees: 10, childs: [] },
                    { percent: 100, name: 14, employees: 10, childs: [] },
                    { percent: 80, name: 15, employees: 10, childs: [] },
                    { percent: 90, name: 16, employees: 10, childs: [] },
                    { percent: 40, name: 17, employees: 10, childs: [] },
                    { percent: 55, name: 18, employees: 10, childs: [] },
                  ]}
                  dataCurrent={[]}
                  dataParent={[]}
                  loading={false}
                />
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}

WidgetResponseRate.propTypes = {}

export default WidgetResponseRate
